module.exports = __webpack_public_path__ + "img/share.a9b106bb.jpg";